import type { AxiosRequestConfig } from 'axios'

import { callAPI, laborerNewDLTransferAPIWithCredentials } from 'api/axios'
import { EToIRequestStatus, GeneralFailResponse } from 'common/types/commonTypes'
import { LIST_ITEMS_PER_PAGE } from 'common/constants'
import { NationalityFromBE, OccupationFromBE } from 'common/types/transformedRespTypes'

export type GetLaborerEToIRequestsParams = {
  page?: number
  perPage?: number
}

export type LaborerEToIRequestFomBe = {
  id: number
  status: EToIRequestStatus
  source: string
  bill: null
  financial_details: null
  created_at: string
  updated_at: string
}

export type GetLaborerEToIRequestsResponse = {
  data: Array<LaborerEToIRequestFomBe>
  meta: {
    last_page: number
  }
}

const getLaborerEToIRequests = (params: GetLaborerEToIRequestsParams, config?: AxiosRequestConfig) =>
  laborerNewDLTransferAPIWithCredentials.get<GetLaborerEToIRequestsResponse>('api/laborers/contracts', {
    params: {
      page: (params.page || 0) + 1,
      per_page: params.perPage || LIST_ITEMS_PER_PAGE,
    },
    ...config,
  })

export interface GetLaborerEToIRequestByIdParams {
  id: string
}

interface LaborerEToIRequestDetailsFromBE {
  id: number
  status: EToIRequestStatus
  created_at: string
  laborer_id_number: string
  laborer_passport_number: string
  laborer_name: string
  laborer_gender: string
  laborer_birth_date: string
  laborer_salary: number
  laborer_current_occupation: OccupationFromBE
  laborer_nationality: NationalityFromBE
  laborer_new_occupation: OccupationFromBE
  employer: {
    id_number: string
    name: string
    email: string
    mobile: string
  }
}

export interface GetLaborerEToIRequestByIdResponse {
  data: LaborerEToIRequestDetailsFromBE
}

const getLaborerEToIRequestById = (params: GetLaborerEToIRequestByIdParams, config?: AxiosRequestConfig) =>
  laborerNewDLTransferAPIWithCredentials.get<GetLaborerEToIRequestByIdResponse>(
    `api/laborers/contracts/${params.id}`,
    {
      ...config,
    },
  )

export interface SubmitReplyForLaborerEToIRequestParams {
  id: number | string
  type: 'accept' | 'reject'
}

const submitReplyForLaborerEToIRequest = (
  params: SubmitReplyForLaborerEToIRequestParams,
  config?: AxiosRequestConfig,
) =>
  laborerNewDLTransferAPIWithCredentials.post<{}>(
    `api/laborers/contracts/${params.id}/${params.type}`,
    {},
    {
      ...config,
    },
  )

export default {
  getLaborerEToIRequests: callAPI<typeof getLaborerEToIRequests, GetLaborerEToIRequestsResponse, GeneralFailResponse>(
    getLaborerEToIRequests,
  ),
  getLaborerEToIRequestById: callAPI<
    typeof getLaborerEToIRequestById,
    GetLaborerEToIRequestByIdResponse,
    GeneralFailResponse
  >(getLaborerEToIRequestById),
  submitReplyForLaborerEToIRequest: callAPI<typeof submitReplyForLaborerEToIRequest, {}, GeneralFailResponse>(
    submitReplyForLaborerEToIRequest,
  ),
}
